import { ActionsCell } from "../../../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../../../Component/Common/Components/DataTable/DefaultCell";
import { FileManagementUploadSearchDto } from "../../../../../Component/Model/Dto/FileManagement";
import { ActionType, TableColumn } from "../../../../../Component/Model/Table/Table";
import { TableDateTimeHelper } from "../../../../../Component/Model/helpers";

interface FileManagementUploadTableRow {
    fileName: string;
    comment?: string;
    dateUploaded: string;
    uploadedBy: string;
    actions: ActionType[];
}

export interface FileManagementUploadTable {
    columns: Array<TableColumn>;
    rows: Array<FileManagementUploadTableRow>;
}

export function FileManagmentUploadTableMapper(results: FileManagementUploadSearchDto[], downloadFile: (id: number) => void): FileManagementUploadTable {
    const columns = [
        { Header: 'Name Of File', accessor: 'fileName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Comments', accessor: 'comment', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} maxWidth={"500px"} emptyValueText="No comment captured." />, disableSortBy: true },
        { Header: 'Date Uploaded', accessor: 'dateUploaded', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Uploaded By', accessor: 'uploadedBy', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true }
    ];


    if (results.length >= 0) {

        const rows = results.map((item: FileManagementUploadSearchDto, index: number) => ({
            fileName: item.fileName,
            comment: item.comment,
            dateUploaded: TableDateTimeHelper(item.dateUploaded.toString()),
            uploadedBy: item.uploadedBy,
            actions: item.documentId > 0 ? [
                {
                    key: index.toString(),
                    label: 'Download File',
                    action: () => {
                        downloadFile(item.documentId);
                    },
                    icon: {
                        color: 'info',
                        name: 'download'
                    }
                },
            ] :
            [
                {
                    key: index.toString(),
                    label: `You're only allowed to download files that you've uploaded`,
                    action: () => {},
                    icon: {
                        color: 'secondary',
                        name: 'download'
                    },
                    disabled: true
                },
            ]

        }));


        return { columns: columns, rows: rows };
    } else {
        return { columns: columns, rows: [] };
    }
}

